export default "__VITE_ASSET__Ct_Igrj7__"